import { styled } from '@abyss/web/tools/styled';
import { Checkbox } from '@abyss/web/ui/Checkbox';
import { Flex } from '@abyss/web/ui/Flex';
import { Layout } from '@abyss/web/ui/Layout';
import { Link } from '@abyss/web/ui/Link';
import { Text } from '@abyss/web/ui/Text';

export const LocationCardContainer = styled('div', {
  margin: '14px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
});

export const LocationCardWrapper = styled(Flex, {
  background: '$primary2',
  width: '100%',
  flexDirection: 'column',
  gap: '4px',
  textAlign: 'left',
  '@screen < $sm': {
    width: '100%',
    height: 'auto',
  },
  '&.location-card-map-view': {
    width: '320px',
    height: '162px',
    '@screen < $sm': {
      height: 'auto',
    },
    '.location-details': {
      '>div': {
        width: 'auto',
        height: 'inherit',
      },
    },
  },
});

export const PreferredBadgeWrapper = styled('div', {
  paddingBottom: '8px',
  '@screen < $sm': {
    paddingBottom: '4px',
  },
});

export const LocationCardGroup = styled(Layout.Group, {
  '&.abyss-layout-group': {
    alignItems: 'flex-start',
    '@screen < $sm': {
      // height: '125px',
    },
  },
});

export const LocationDetailsStack = styled(Flex, {
  flex: 1,
  minWidth: 0,
  gap: '8px',
  lineHeight: '23px',
  '@screen < $sm': {
    lineHeight: '18px',
  },
  '>span': {
    overflowWrap: 'anywhere',
    width: '100%',
  },
});

export const LocationDetailsAddress = styled(Text, {
  lineHeight: '24px',
  fontSize: '18px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  maxWidth: '342px',
  '@screen < $sm': {
    lineHeight: '20px',
    fontSize: '14.22px',
    maxWidth: '258px',
  },
});

export const LocationBadgeRow = styled(Flex, {
  gap: '16px',
  flexDirection: 'row',
  flexWrap: 'nowrap',
});

export const AddressDetailsWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
});

export const MilesButton = styled('div', {
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
});

export const AcceptingNewPatientsBadge = styled('div', {
  display: 'flex',
  gap: '4px',
  alignItems: 'center',
  fontSize: '12px',
});

export const StyledCheckIcon = styled('div', {
  height: '24px',
});

export const SelectLocationCheckbox = styled(Checkbox, {
  '&.abyss-checkbox': {
    '&&:disabled': {
      backgroundColor: '$gray4',
      borderColor: '$gray6',
    },
    '&&:checked:disabled': {
      backgroundColor: '$gray6',
      borderColor: '$gray6',
    },
  },
})

export const ModalPhoneText = styled(Text, {
  lineHeight: '18px',
  fontWeight: '500',
  padding: '0 4px !important',
  cursor: 'pointer',
  '@screen < $sm': {
    fontSize: '16px !important',
  }
})

export const PhoneTag = styled('a', {
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
  '&:hover,&:active': {
    textDecoration: 'none',
  },
  marginTop: '0.5rem',
});

export const PhoneLink = styled(Link, {
  display: 'flex',
  gap: '4px',
  width: 'fit-content',
});

export const CardContentRow = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  width: '100%',
});

export const CheckboxWrapper = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
});